var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container", title: "新增地址" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "company-wrapper" }, [
            _c("img", {
              staticClass: "location_icon",
              attrs: {
                src: require("../assets/img/home/companyAddress.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "companyName" }, [
              _vm._v(_vm._s(_vm.subcompanyName))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sanjiao_down" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "companyList-wrapper" }, [
            _c("div", { staticClass: "currentCompany" }, [
              _c("div", { staticClass: "desc" }, [_vm._v("当前/已选子公司")]),
              _vm._v(" "),
              _c("div", { staticClass: "item-name" }, [
                _c("span", { staticClass: "active name" }, [
                  _vm._v(_vm._s(_vm.subcompanyName))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-wrapper" },
              [
                _c("div", { staticClass: "list-title" }, [
                  _vm._v("子公司列表")
                ]),
                _vm._v(" "),
                _vm._l(_vm.companyList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "list-item",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.selectCompany(item)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "item-name" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.subcompanyName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-area-box" }, [
                        _c("div", { staticClass: "area-item" }, [
                          _vm._v(_vm._s(item.subcompanyAddress))
                        ])
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }